import React from "react";

import Loading from "../../components/Loading";

import layout from '../../components/layout';
import { useAuth0 } from "../../react-auth0-spa";

import './styles.scss';

const Dashboard = () => {
  const { loading, user } = useAuth0();

  if (loading || !user) {
    return <Loading />;
  }

  return (
    <React.Suspense fallback={<Loading />}>
      <div className="dashboard-page page-container">
        <div className="header">
          <h1 className="title">Dashboard</h1>
        </div>
      </div>
    </React.Suspense>
  );
};

export default layout(Dashboard);
